const idNotNull = (id) => {
  if (id === null) return "0";
  return id;
}

const objectIDNotNull = (id, level = 4) => {
  if (level === 3) return objectIDLevel3NotNull(id);
  return objectIDLevel4NotNull(id);
}
const objectIDLevel3NotNull = (id) => {
  if (!id || id.level1 === null) return { 
    level1: "0", 
    level2: null, 
    level3: null,
  }; // empty => all
  return { 
    level1: id.level1, 
    level2: id.level2, 
    level3: id.level3,
  };
}
const objectIDLevel4NotNull = (id) => {
  if (!id || id.level1 === null) return { 
    level1: "0", 
    level2: null, 
    level3: null,
    level4: null,
  }; // empty => all
  return { 
    level1: id.level1, 
    level2: id.level2, 
    level3: id.level3,
    level4: id.level4,
  };
}
const objectIDToString = (id) => {
  return (id && Object.values(id).filter(Boolean).join('-')) || null; // aaa-bbb-ccc-ddd || null
}

export {
  idNotNull,
  objectIDNotNull,
}
export default {
  idNotNull,
  objectIDNotNull,
  objectIDToString,
}